const initialState = {
	data: [],
	total: 0,
	params: {},
}

const fraudipblacklist = (state = initialState, action) => {
	switch (action.type) {
		case 'FRAUDIPBLACKLIST_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'FRAUDIPBLACKLIST_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'FRAUDIPBLACKLIST_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		default:
			return state
	}
}

export default fraudipblacklist
